webpackJsonp([104101334113578],{

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Colors = __webpack_require__(41);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPagePhoto = function (_React$Component) {
	    _inherits(IndexPagePhoto, _React$Component);
	
	    function IndexPagePhoto(props) {
	        _classCallCheck(this, IndexPagePhoto);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            hover: false
	        };
	
	        _this.onHover = _this.onHover.bind(_this);
	        _this.onHoverOff = _this.onHoverOff.bind(_this);
	        return _this;
	    }
	
	    IndexPagePhoto.prototype.onHover = function onHover() {
	        this.setState({ hover: true });
	    };
	
	    IndexPagePhoto.prototype.onHoverOff = function onHoverOff() {
	        this.setState({ hover: false });
	    };
	
	    IndexPagePhoto.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: this.props.isNarrow ? "column is-narrow" : "column" },
	            _react2.default.createElement(
	                'figure',
	                { className: 'image wow fadeInUp fast',
	                    style: { borderColor: _Colors2.default[this.props.color] },
	                    onMouseEnter: this.onHover,
	                    onMouseLeave: this.onHoverOff },
	                _react2.default.createElement(
	                    'a',
	                    { href: this.props.link },
	                    _react2.default.createElement('img', { style: { display: this.state.hover ? 'none' : 'block' }, src: this.props.mainImageUrl })
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: this.props.link },
	                    _react2.default.createElement('img', { style: { display: this.state.hover ? 'block' : 'none' }, src: this.props.hoverImageUrl })
	                )
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'subtitle', style: { color: _Colors2.default[this.props.color] } },
	                this.props.caption
	            )
	        );
	    };
	
	    return IndexPagePhoto;
	}(_react2.default.Component);
	
	IndexPagePhoto.propTypes = {
	    mainImageUrl: _propTypes2.default.string,
	    hoverImageUrl: _propTypes2.default.string,
	    caption: _propTypes2.default.string,
	    color: _propTypes2.default.string,
	    isNarrow: _propTypes2.default.bool,
	    link: _propTypes2.default.string
	};
	
	exports.default = IndexPagePhoto;
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.indexPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _IndexPagePhoto = __webpack_require__(292);
	
	var _IndexPagePhoto2 = _interopRequireDefault(_IndexPagePhoto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	    _inherits(IndexPage, _React$Component);
	
	    function IndexPage(props) {
	        _classCallCheck(this, IndexPage);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        var data = _this.props.data;
	        var page = data.markdownRemark;
	
	        var photos = page.frontmatter.photos;
	        var pairedPhotos = [];
	
	        for (var i = 0; i < photos.length; i += 2) {
	            var pair = [];
	            if (photos[i]) pair.push(photos[i]);
	            if (photos[i + 1]) pair.push(photos[i + 1]);
	            pairedPhotos.push(pair);
	        }
	
	        _this.state = {
	            page: page.frontmatter,
	            photosInPair: pairedPhotos
	        };
	
	        return _this;
	    }
	
	    IndexPage.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { className: 'section body section-content-wrapper' },
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: '' + this.state.page.title,
	                bodyAttributes: {
	                    class: "page-home theme-orange"
	                } }),
	            _react2.default.createElement(
	                'div',
	                { className: 'projects' },
	                this.state.photosInPair.map(function (photo, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: index, className: 'project columns' },
	                        _react2.default.createElement(_IndexPagePhoto2.default, {
	                            link: photo[0].link,
	                            mainImageUrl: photo[0].mainImageUrl,
	                            hoverImageUrl: photo[0].hoverImageUrl,
	                            caption: photo[0].caption,
	                            color: photo[0].color,
	                            isNarrow: true }),
	                        photo[1] ? _react2.default.createElement(_IndexPagePhoto2.default, {
	                            link: photo[1].link,
	                            mainImageUrl: photo[1].mainImageUrl,
	                            hoverImageUrl: photo[1].hoverImageUrl,
	                            caption: photo[1].caption,
	                            color: photo[1].color,
	                            isNarrow: false }) : null
	                    );
	                })
	            )
	        );
	    };
	
	    return IndexPage;
	}(_react2.default.Component);
	
	IndexPage.propTypes = {
	    data: _propTypes2.default.shape({
	        markdownRemark: _propTypes2.default.object
	    })
	};
	exports.default = IndexPage;
	var indexPageQuery = exports.indexPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-index-js-e21bf66cef5da631a5cc.js